var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "white--text important-links pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { attrs: { justify: "space-between", dense: "" } },
            [
              _c(
                "v-col",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { cols: "6", sm: "6" }
                },
                [
                  _c("strong", [
                    _c(
                      "a",
                      {
                        staticClass: "no-decoration white--text",
                        attrs: {
                          href: _vm.$t("footer.moreInformationPdf"),
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("footer.moreInformation")))]
                    )
                  ])
                ]
              ),
              _c(
                "v-col",
                { staticClass: "text-right", attrs: { cols: "6", sm: "6" } },
                [
                  _c("strong", [
                    _c(
                      "a",
                      {
                        staticClass: "no-decoration white--text",
                        attrs: {
                          href: _vm.$t("footer.privacyPolicyPdf"),
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("footer.privacyPolicy")))]
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }